import * as React from 'react';
import { Route } from 'react-router';
import Layout from './components/Layout';
import Home from './components/Home';
import Login from './components/LoginForm';
import OutletSearchSetWrapper from './components/OutletSearchForm/OutletSearchSetWrapper';
import { alertActions } from './actions/alert.actions';
import './custom.css'
import { PrivateRoute } from './components/PrivateRoute';

export default () => (
  

    <Layout>
        <PrivateRoute exact path="/" component={OutletSearchSetWrapper} />
        <Route path="/login" component={Login} />
        <PrivateRoute path='/OutletSearch-Form/:searchString?' component={OutletSearchSetWrapper} />
    

    </Layout>
);
